import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { AlertCircle } from 'lucide-react';

const Disclaimer = () => {
  return (
    <div className="min-h-screen bg-white py-16">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">
        <h1 className="text-4xl md:text-5xl font-bold text-black mb-8">
          Descargo de Responsabilidad
        </h1>

        <div className="space-y-6">
          <Card className="border-2 bg-gray-50">
            <CardContent className="pt-6">
              <div className="flex items-start gap-4">
                <AlertCircle className="h-8 w-8 text-black flex-shrink-0 mt-1" />
                <div className="space-y-4 text-gray-700 leading-relaxed">
                  <p className="font-semibold text-black text-lg">
                    Video Vault no está afiliado, patrocinado ni respaldado por Instagram, Facebook o Meta.
                  </p>
                  <p>
                    Todas las marcas y nombres pertenecen a sus respectivos dueños.
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>

          <Card className="border-2">
            <CardContent className="pt-6">
              <h2 className="text-xl font-semibold text-black mb-4">
                Sobre el contenido de terceros
              </h2>
              <p className="text-gray-700 leading-relaxed">
                El contenido al que se accede mediante enlaces pertenece a terceros y se entrega desde 
                la plataforma original. Video Vault no aloja, no almacena ni publica esos videos.
              </p>
            </CardContent>
          </Card>

          <Card className="border-2 bg-yellow-50">
            <CardContent className="pt-6">
              <h2 className="text-xl font-semibold text-black mb-4">
                Responsabilidad del usuario
              </h2>
              <p className="text-gray-700 leading-relaxed">
                El usuario es responsable de usar la herramienta de forma legal y con los permisos 
                correspondientes. Video Vault proporciona un servicio técnico pero no controla ni valida 
                los derechos sobre el contenido descargado.
              </p>
            </CardContent>
          </Card>

          <Card className="border-2">
            <CardContent className="pt-6">
              <h2 className="text-xl font-semibold text-black mb-4">
                Propiedad intelectual
              </h2>
              <p className="text-gray-700 leading-relaxed">
                Si sos titular de derechos de autor sobre algún contenido y considerás que se está 
                infringiendo tu propiedad intelectual, contactanos en{' '}
                <a href="mailto:support@cloudcentercr.com" className="font-semibold text-black hover:underline">
                  support@cloudcentercr.com
                </a>
                {' '}para solicitar una revisión.
              </p>
            </CardContent>
          </Card>

          <div className="bg-gray-50 border-2 p-6 rounded-lg">
            <p className="text-gray-700 text-sm leading-relaxed">
              <strong className="text-black">Nota legal:</strong> Este descargo de responsabilidad está 
              sujeto a cambios. El uso continuado del servicio después de modificaciones constituye la 
              aceptación de los nuevos términos.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Disclaimer;
